export default __webpack_public_path__ + "static/media/icon_power_outage_true.b18cf461.svg";